module.exports = __webpack_public_path__ + "img/ELEPHANT.cc7355d.svg";